export default function Spinner({ size = 20, color = 'var(--accent)' }: { size?: number; color?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      style={{ animation: 'spin 0.6s linear infinite' }}
    >
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
      <circle
        cx="12" cy="12" r="10"
        fill="none"
        stroke={color}
        strokeWidth="3"
        strokeDasharray="32"
        strokeLinecap="round"
        opacity={0.3}
      />
      <circle
        cx="12" cy="12" r="10"
        fill="none"
        stroke={color}
        strokeWidth="3"
        strokeDasharray="32"
        strokeDashoffset="24"
        strokeLinecap="round"
      />
    </svg>
  )
}
